export default [
    {
        // [0]
        key: "personal_name",
        label: app.$i18n.t("Employee"),
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "justification_date",
        label: app.$i18n.t("Date"),
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        // [2]
        key: "justification_type",
        label: app.$i18n.t("Type"),
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        // [3]
        key: "justification_obs",
        label: app.$i18n.t("Observation"),
        thClass: "text-center",
        tdClass: "text-center",
        sortable: false,
        visible: true,
    },
    {
        // [4]
        key: "justification_status",
        label: app.$i18n.t("Status"),
        thClass: "text-center",
        tdClass: "text-center",
        sortable: false,
        visible: true,
    },
    {
        // [5]
        key: "created_by",
        label: app.$i18n.t("Created By"),
        thClass: "text-left",
        tdClass: "text-left",
        sortable: false,
        visible: true,
    },
    {
        // [6]
        key: "actions",
        label: app.$i18n.t("Actions"),
        thClass: "text-center",
        tdClass: "text-center",
        sortable: false,
        visible: true,
    },

]